import Quiz from "./component/Quiz";

function App() {
  return (
    <div className="App">
      <Quiz />
    </div>
  );
}

export default App;